import { render } from "./RegionalPage.vue?vue&type=template&id=98035dca&scoped=true"
import script from "./RegionalPage.vue?vue&type=script&lang=js"
export * from "./RegionalPage.vue?vue&type=script&lang=js"

import "./RegionalPage.vue?vue&type=style&index=0&id=98035dca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98035dca"]])

export default __exports__